/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeResourceForm } from '../../AttributeResourceForm'

export const AttributeResourceDialogUpdate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  resource,
  parameters,
  actionUpdateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.resources.update.scenario')
    : currentProject
    ? t('attributes.resources.update.project')
    : t('attributes.resources.update.global')

  /**
   * Action received from the Resource Form.
   * @see AttributeResourceForm
   *
   * @param {object} newResource Resource attribute object to update.
   * @param {string} newResourceId Resource attribute Id to update.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newResource, newResourceId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeResourceDialogUpdate.onDispatchAction()', {
      newResource,
      newResourceId,
      actionUpdateDispatch,
      currentProject,
      currentScenario
    })

    dispatch(actionUpdateDispatch(newResource, newResourceId, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'AttributeResourceDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).then()',
          {
            res
          }
        )
        if (res?.data?.isAxiosError) {
          enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
        } else if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(
          LoggerTypes.WARN,
          'AttributeResourceDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).catch()',
          { res }
        )

        checkErrorResponse(res, enqueueSnackbar, t)

        if (res?.response?.data?.fields) {
          setErrors(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeResourceDialogUpdate.render()', {
    currentProject,
    currentScenario,
    resource,
    parameters
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeResourceForm
        title={title}
        setOpenDialog={setOpenDialog}
        resource={resource}
        parameters={parameters}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeResourceDialogUpdate.displayName = 'AttributeResourceDialogUpdate'

AttributeResourceDialogUpdate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionUpdateDispatch: PropTypes.func.isRequired,
  parameters: PropTypes.arrayOf(PropTypes.object),
  resource: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    quantity: PropTypes.number,
    worktime_start: PropTypes.string,
    worktime_end: PropTypes.string,
    non_working_days: PropTypes.arrayOf(PropTypes.string),
    non_working_period_start: PropTypes.string,
    non_working_period_end: PropTypes.string
  }).isRequired
}

AttributeResourceDialogUpdate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionUpdateDispatch: null,
  parameters: [],
  resource: {
    id: null,
    name: null,
    description: null,
    type: null,
    quantity: null,
    worktime_start: null,
    worktime_end: null,
    non_working_days: null,
    non_working_period_start: null,
    non_working_period_end: null
  }
}
